export enum HalalShopPageSection {
  Orders = 'orders',
  Catalog = 'catalog',
  Establishment = 'establishment',
  Returns = 'returns',
  Finances = 'finances',
  Statistic = 'statistic',
}
